import styled from "styled-components"

export const Container = styled.section`
  display: flex;
  margin: 0rem 2.68rem;
  button { // Arrow do Carousel
    color: black;
  }

  .rec-arrow-right {
    position: absolute;
    top: 13%;
    right: 8%;
    background: white;
    
    &:hover, &:focus {
      background: black !important;
      color: white;
    }

    &:after {
      content: 'Próximo';
      opacity: 0.4;
      position: absolute;
      top: 2.2rem;
      left: -10px;
      font-size: 1.2rem;
      color: black;
    }
  }

  .rec-arrow-left {
    position: absolute;
    top: 13%;
    right: 15%;
    background: white;

    &:hover, &:focus {
      background: black !important;
      color: white;
    }

    &:after {
      content: 'Voltar';
      opacity: 0.4;
      position: absolute;
      top: 2.2rem;
      left: 0px;
      font-size: 1.2rem;
      color: black;
    }
  }

  @media (max-width: 1000px) {
    margin: 0rem;

    .rec-arrow {
      display: none;
    }
  }
`